/**
 * Component mapping for the numbered update steps rendered via <Trans> by the
 * Canvas and D2L LTI field-mapping help pages.
 */
export const stepComponents = {
  ol: <ol className="ml-5 list-decimal" />,
  li: <li className="pb-2" />,
  b: <strong />,
}
